import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SegundaViaResponse } from 'src/app/shared/models/segunda-via-response.model';
import { MensagensService } from 'src/app/shared/mensagens/mensagens.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EnviaLinhaDigitavelModalComponent } from './envia-linha-digitavel-modal/envia-linha-digitavel-modal.component';
import { EnviaLinhaDigitalModalData } from 'src/app/shared/models/envia-linha-digitavel-modal-data';
import DateUtils from 'src/app/shared/utils/date-utils';
import { isMatch, format } from 'date-fns';
import { PerfilService } from 'src/app/perfil/perfil.service';
import PerfilCliente from 'src/app/shared/models/perfil-cliente.model';

@Component({
  selector: 'app-boleto-parcela',
  templateUrl: './boleto-parcela.component.html',
  styleUrls: ['./boleto-parcela.component.scss']
})
export class BoletoParcelaComponent implements OnInit {

  @Input()
  showAlert: boolean;

  @Input()
  dadosBoleto: SegundaViaResponse;

  @Input()
  showDownloadButton = true;

  @Output()
  downloadBoleto = new EventEmitter<boolean>();

  @Output()
  enviarBoleto: EventEmitter<EnviaLinhaDigitalModalData> = new EventEmitter<EnviaLinhaDigitalModalData>();

  @Input()
  isRenegociacao: boolean;

  emotionImage = '../../assets/images/emoticon.svg';

  copiado = false;

  baixado = false;

  @Input()
  disabledSms = false;

  @Input()
  disabledEmail = false;

  @Output()
  pagarPix: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  permitirPagamentoPix = false;


  clientePerfil?: PerfilCliente;

  constructor(
    private mensagens: MensagensService,
    private dialog: MatDialog,
    private perfilService: PerfilService,
  ) { }

  ngOnInit(): void {
    this.buscarClientePerfil();
    this.emotionBlink();
  }

  async buscarClientePerfil() {
    try {
      const clientePerfil = await this.perfilService.getPerfil();
      if (clientePerfil) {
        this.clientePerfil = clientePerfil;
        if (this.clientePerfil.celular) {
          this.clientePerfil.celular = this.clientePerfil.celular.substring(3);
        }
      }
    } catch (response) { }
  }

  private emotionBlink(): void {
    setInterval(() => this.emotionImage = '', 1500);
    setInterval(() => this.emotionImage = 'wink', 2500);
  }

  convertToDatabaseDate(date: string): string {
    if (isMatch(date, 'dd/MM/yyyy')) {
      return date;
    }

    if (date) {
      const normalizedDate = DateUtils.normalizedDate(date);
      return format(normalizedDate, 'dd/MM/yyyy');
    }

    return null;
  }

  copiarLinhaDigitavel(): void {
    this.copiado = true;
    this.mensagens.sucesso('Linha digitável copiada!');
  }

  baixarBoleto(): void {
    this.baixado = true;
    this.downloadBoleto.next();
  }

  enviarLinhaDigitavelSms() {
    if (!this.clientePerfil.celular) {
      return;
    }

    const modalConfig: MatDialogConfig<EnviaLinhaDigitalModalData> = {
      data: { type: 'SMS', initialValue: this.clientePerfil.celular },
      width: '100%',
      maxWidth: '380px',
    };

    this.dialog.open(EnviaLinhaDigitavelModalComponent, modalConfig).afterClosed().subscribe((usuario) => {
      if (usuario) {
        this.enviarBoleto.emit({ type: 'SMS', usuario });
      }
    });
  }

  enviarLinhaDigitavelEmail() {
    if (!this.clientePerfil.email) {
      return;
    }

    const modalConfig: MatDialogConfig<EnviaLinhaDigitalModalData> = {
      data: { type: 'EMAIL', initialValue: this.clientePerfil.email },
      width: '100%',
      maxWidth: '380px',
    };

    this.dialog.open(EnviaLinhaDigitavelModalComponent, modalConfig).afterClosed().subscribe((usuario) => {
      if (usuario) {
        this.enviarBoleto.emit({ type: 'EMAIL', usuario });
      }
    });
  }

  pagarComPix() {
    this.pagarPix.emit();
  }

}
